/**
 * Landing Page Hero Section
 * ZO Bull Algo Trading Platform
 */
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface LandingHeroProps {
  onGetStarted?: () => void
}

export default function LandingHero({ onGetStarted }: LandingHeroProps) {
  const { t } = useTranslation();
  const authToken = localStorage.getItem('auth_token');
  const isLoggedIn = !!authToken;
  
  return (
    <section className="landing-hero">
      <div className="hero-background">
        <div className="hero-gradient"></div>
        <div className="hero-particles">
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
          <div className="particle"></div>
        </div>
      </div>
      
      <div className="hero-content">
        <div className="hero-badge">
          <span className="badge-icon">🚀</span>
          <span>{t('landing.version')} 6.2.0 - {t('landing.nowWith')} 274+ {t('landing.indicatorsAnd')} 60+ {t('landing.patterns')}</span>
        </div>
        
        <h1 className="hero-title">
          <span className="hero-title-line">{t('landing.tradeSmarter')}</span>
          <span className="hero-title-highlight">{t('landing.aiPoweredTrading')}</span>
        </h1>
        
        <p className="hero-subtitle">
          {t('landing.heroSubtitle')}
        </p>
        
        <div className="hero-stats">
          <div className="stat-item">
            <span className="stat-value">274+</span>
            <span className="stat-label">{t('landing.indicators')}</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-value">94</span>
            <span className="stat-label">{t('landing.brokers')}</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-value">42</span>
            <span className="stat-label">{t('landing.languages')}</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-value">13</span>
            <span className="stat-label">{t('landing.themes')}</span>
          </div>
        </div>
        
        <div className="hero-actions">
          {isLoggedIn ? (
            <Link to="/dashboard" className="btn btn-primary btn-lg hero-cta">
              <span className="btn-icon">📊</span>
              {t('landing.goToDashboard')}
            </Link>
          ) : (
            <Link to="/register" className="btn btn-primary btn-lg hero-cta">
              <span className="btn-icon">⚡</span>
              {t('landing.startFreeTrial')}
            </Link>
          )}
          {!isLoggedIn && (
            <Link to="/login" className="btn btn-secondary btn-lg hero-cta-secondary">
              <span className="btn-icon">🔑</span>
              {t('landing.login')}
            </Link>
          )}
        </div>
        
        <div className="hero-trust">
          <span className="trust-label">{t('landing.trustedByTraders')}</span>
          <div className="trust-badges">
            <span className="trust-badge">🔒 {t('landing.enterpriseSecurity')}</span>
            <span className="trust-badge">⚡ {t('landing.uptime')}</span>
            <span className="trust-badge">🌍 {t('landing.multiLanguage')}</span>
            <span className="trust-badge">📊 {t('landing.optionsTrading')}</span>
            <span className="trust-badge">🤖 {t('landing.aiSignals')}</span>
            <span className="trust-badge">🔗 {t('landing.tradetron')}</span>
          </div>
        </div>
      </div>
      
      <div className="hero-visual">
        <div className="hero-dashboard-preview">
          <div className="preview-header">
            <div className="preview-dots">
              <span></span><span></span><span></span>
            </div>
            <span className="preview-title">ZO Bull Dashboard</span>
          </div>
          <div className="preview-content">
            <div className="preview-chart">
              <div className="chart-line"></div>
              <div className="chart-bars">
                <div className="bar" style={{height: '60%'}}></div>
                <div className="bar" style={{height: '80%'}}></div>
                <div className="bar" style={{height: '45%'}}></div>
                <div className="bar" style={{height: '90%'}}></div>
                <div className="bar" style={{height: '70%'}}></div>
              </div>
            </div>
            <div className="preview-stats">
              <div className="preview-stat">
                <span className="preview-stat-value positive">+24.5%</span>
                <span className="preview-stat-label">Today's Return</span>
              </div>
              <div className="preview-stat">
                <span className="preview-stat-value">$125,430</span>
                <span className="preview-stat-label">Portfolio Value</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="hero-floating-card card-1">
          <span className="floating-icon">📈</span>
          <div className="floating-text">
            <span className="floating-value">RSI Signal</span>
            <span className="floating-status">Bullish</span>
          </div>
        </div>
        
        <div className="hero-floating-card card-2">
          <span className="floating-icon">🤖</span>
          <div className="floating-text">
            <span className="floating-value">AI Copilot</span>
            <span className="floating-status">Active</span>
          </div>
        </div>
        
        <div className="hero-floating-card card-3">
          <span className="floating-icon">🔔</span>
          <div className="floating-text">
            <span className="floating-value">Alert</span>
            <span className="floating-status">New Trade</span>
          </div>
        </div>
      </div>
    </section>
  )
}
